import { render, staticRenderFns } from "./AttachPatientModal.vue?vue&type=template&id=56e88422&scoped=true"
import script from "./AttachPatientModal.vue?vue&type=script&lang=js"
export * from "./AttachPatientModal.vue?vue&type=script&lang=js"
import style0 from "./AttachPatientModal.vue?vue&type=style&index=0&id=56e88422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e88422",
  null
  
)

export default component.exports